const axios = require('axios');

import {
	serverUrl,
} from '../properties'
const dataUrl = serverUrl;

export default {
	namespaced: true,
	state: {
        selectedAccount: undefined,
        issuesList: [],
        showPerPage: 25,
        totalCount: undefined,
        selectedProduct: undefined,
        productAdvanceFilter: {},
        issueFilters: {},
        filterOptions: { work_status: []},
        selectedIssues: [],
        actionSelectionControl: undefined
	},
	mutations: {
        setadvanceFilterProduct: (state, data) => {
			state.productAdvanceFilter = data
		},
        setIssueFilters: (state, data) => {
			state.issueFilters = data
		},
    },
    getters: {
	},
	actions: {
        list:({commit,state,rootState,rootGetters},payload) => {
            commit('showLoadingSpinner', null, { root: true });
            return new Promise((resolve,reject) =>{
                axios({
                    url:dataUrl+'/productAlerts/list',
                    method:'POST',
                    data:payload || {},
                    headers: rootGetters.fetchHeader,
                    responseType: 'json'
                }).then((response) =>{
                    if(response.data){
                        console.log('STATE TOTALCOUNT: ', state.totalCount)
                        state.totalCount = response.data[0] ? response.data[0].full_count : 0
                        commit('hideLoadingSpinner', null, { root: true })
                        resolve(response.data)
                    }
                }).catch((error)=>{
                    console.log(error)
                    commit('hideLoadingSpinner', null, { root: true })
                    reject(error)
                })
            })
        },
        getProductHistory:({commit,state,rootState,rootGetters},payload) => {
            commit('showLoadingSpinner', null, { root: true });
            return new Promise((resolve,reject) =>{
                axios({
                    url:dataUrl+'/productAlerts/getHistory',
                    method:'POST',
                    data:payload || {},
                    headers: rootGetters.fetchHeader,
                    responseType: 'json'
                }).then((response) =>{
                    if(response.data){
                        // console.log('STATE TOTALCOUNT: ', state.totalCount)
                        // state.totalCount = response.data[0] ? response.data[0].full_count : 0
                        commit('hideLoadingSpinner', null, { root: true })
                        resolve(response.data)
                    }
                }).catch((error)=>{
                    console.log(error)
                    commit('hideLoadingSpinner', null, { root: true })
                    reject(error)
                })
            })
        },
        getWorkHistory:({commit,state,rootState,rootGetters},payload) => {
            commit('showLoadingSpinner', null, { root: true });
            return new Promise((resolve,reject) =>{
                axios({
                    url:dataUrl+'/productAlerts/getWorkHistory',
                    method:'POST',
                    data:payload || {},
                    headers: rootGetters.fetchHeader,
                    responseType: 'json'
                }).then((response) =>{
                    if(response.data){
                        // console.log('STATE TOTALCOUNT: ', state.totalCount)
                        // state.totalCount = response.data[0] ? response.data[0].full_count : 0
                        commit('hideLoadingSpinner', null, { root: true })
                        resolve(response.data)
                    }
                }).catch((error)=>{
                    console.log(error)
                    commit('hideLoadingSpinner', null, { root: true })
                    reject(error)
                })
            })
        },
        getFilters:({commit,state,rootState,rootGetters},payload) => {
            return new Promise((resolve,reject) =>{
                axios({
                    url:dataUrl+'/productAlerts/getFilters',
                    method:'POST',
                    data:payload || {},
                    headers: rootGetters.fetchHeader,
                    responseType: 'json'
                }).then((response) =>{
                    if(response.data){
                        resolve(response.data)
                    }
                }).catch((error)=>{
                    console.log(error)
                    reject(error)
                })
            })
        },
        listAccounts:({commit,state,rootState,rootGetters},payload) => {
            return new Promise((resolve,reject) =>{
                axios({
                    url:dataUrl+'/productAlerts/accounts',
                    method:'POST',
                    data:payload,
                    headers: rootGetters.fetchHeader,
                    responseType: 'json'
                }).then((response) =>{
                    if(response.data){
                        resolve(response.data)
                    }
                }).catch((error)=>{
                    console.log(error)
                    reject(error)
                })
            })
        },
        listVendors:({commit,state,rootState,rootGetters},payload) => {
            return new Promise((resolve,reject) =>{
                axios({
                    url:dataUrl+'/productAlerts/vendors',
                    method:'POST',
                    data:payload,
                    headers: rootGetters.fetchHeader,
                    responseType: 'json'
                }).then((response) =>{
                    if(response.data){
                        resolve(response.data)
                    }
                }).catch((error)=>{
                    console.log(error)
                    reject(error)
                })
            })
        },
        listSellers:({commit,state,rootState,rootGetters},payload) => {
            return new Promise((resolve,reject) =>{
                axios({
                    url:dataUrl+'/productAlerts/sellers',
                    method:'POST',
                    data:payload,
                    headers: rootGetters.fetchHeader,
                    responseType: 'json'
                }).then((response) =>{
                    if(response.data){
                        resolve(response.data)
                    }
                }).catch((error)=>{
                    console.log(error)
                    reject(error)
                })
            })
        },
        setWorkedStatus:({commit,state,rootState,rootGetters},payload) => {
            commit('showLoadingSpinner', null, { root: true });
            payload.userName = JSON.parse(window.localStorage.session).name;
            return new Promise((resolve,reject) =>{
                axios({
                    url:dataUrl+'/productAlerts/setWorkedStatus',
                    method:'POST',
                    data:payload,
                    headers: rootGetters.fetchHeader,
                    responseType: 'json'
                }).then((response) =>{
                    if(response.data){
                        commit('hideLoadingSpinner', null, { root: true })
                        resolve(response.data)
                    }
                }).catch((error)=>{
                    console.log(error)
                    commit('hideLoadingSpinner', null, { root: true })
                    reject(error)
                })
            })
        },
        deleteIssueWorked:({commit,state,rootState,rootGetters},payload) => {
            commit('showLoadingSpinner', null, { root: true });
            payload.userName = JSON.parse(window.localStorage.session).name;
            return new Promise((resolve,reject) =>{
                axios({
                    url:dataUrl+'/productAlerts/deleteIssueWorked',
                    method:'POST',
                    data:payload,
                    headers: rootGetters.fetchHeader,
                    responseType: 'json'
                }).then((response) =>{
                    if(response.data){
                        commit('hideLoadingSpinner', null, { root: true })
                        resolve(response.data)
                    }
                }).catch((error)=>{
                    console.log(error)
                    commit('hideLoadingSpinner', null, { root: true })
                    reject(error)
                })
            })
        },
        export:({commit,state,rootState,rootGetters},payload) => {
            payload.userEmail = JSON.parse(window.localStorage.session).username
            return new Promise((resolve,reject) =>{
                axios({
                    url:dataUrl+'/productAlerts/export',
                    method:'POST',
                    data:payload,
                    headers: rootGetters.fetchHeader,
                    responseType: 'json'
                }).then((response) =>{
                    if(response.data){
                        resolve(response.data)
                    }
                }).catch((error)=>{
                    console.log(error)
                    reject(error)
                })
            })
        }
    }
}